import { useState } from "react";
import { useNavigate } from "react-router-dom";
import { Search } from "lucide-react";
import { Select, SelectTrigger, SelectValue, SelectContent, SelectItem } from "./ui/select";
import { Input } from "./ui/input";

const ROOMS = ["1+0", "1+1", "2+1", "3+1", "4+1", "5+1"];

export const SearchBox = () => {
  const nav = useNavigate();
  const [f, setF] = useState({ islem: "satilik", tip: "", konum: "", min: "", max: "", oda: "" });

  const submit = (e) => {
    e.preventDefault();
    const params = new URLSearchParams();
    if (f.islem) params.set("islem", f.islem);
    if (f.tip) params.set("tip", f.tip);
    if (f.konum) params.set("q", f.konum);
    if (f.min) params.set("min", f.min);
    if (f.max) params.set("max", f.max);
    if (f.oda) params.set("oda", f.oda);
    nav(`/ilanlar?${params.toString()}`);
  };

  return (
    <form
      onSubmit={submit}
      data-testid="search-box"
      className="backdrop-blur-xl bg-white/95 border border-white/60 shadow-[0_20px_50px_-20px_rgba(15,23,42,.35)] rounded-2xl p-3 sm:p-4"
    >
      <div className="grid grid-cols-2 lg:grid-cols-12 gap-2.5 items-end">
        <div className="col-span-1 lg:col-span-2">
          <label className="label-caps block mb-1">İşlem</label>
          <Select value={f.islem} onValueChange={(v) => setF({ ...f, islem: v })}>
            <SelectTrigger data-testid="search-islem" className="h-10 bg-white text-sm"><SelectValue /></SelectTrigger>
            <SelectContent>
              <SelectItem value="satilik">Satılık</SelectItem>
              <SelectItem value="kiralik">Kiralık</SelectItem>
            </SelectContent>
          </Select>
        </div>
        <div className="col-span-1 lg:col-span-2">
          <label className="label-caps block mb-1">Tip</label>
          <Select value={f.tip} onValueChange={(v) => setF({ ...f, tip: v === "all" ? "" : v })}>
            <SelectTrigger data-testid="search-tip" className="h-10 bg-white text-sm"><SelectValue placeholder="Tümü" /></SelectTrigger>
            <SelectContent>
              <SelectItem value="all">Tümü</SelectItem>
              <SelectItem value="daire">Daire</SelectItem>
              <SelectItem value="villa">Villa</SelectItem>
              <SelectItem value="arsa">Arsa</SelectItem>
              <SelectItem value="isyeri">İşyeri</SelectItem>
              <SelectItem value="diger">Diğer</SelectItem>
            </SelectContent>
          </Select>
        </div>
        <div className="col-span-2 lg:col-span-3">
          <label className="label-caps block mb-1">Konum</label>
          <Input data-testid="search-konum" placeholder="Bursa, Nilüfer" className="h-10 bg-white text-sm" value={f.konum} onChange={(e) => setF({ ...f, konum: e.target.value })} />
        </div>
        <div className="col-span-1 lg:col-span-1">
          <label className="label-caps block mb-1">Min ₺</label>
          <Input data-testid="search-min" type="number" placeholder="0" className="h-10 bg-white text-sm" value={f.min} onChange={(e) => setF({ ...f, min: e.target.value })} />
        </div>
        <div className="col-span-1 lg:col-span-1">
          <label className="label-caps block mb-1">Max ₺</label>
          <Input data-testid="search-max" type="number" placeholder="∞" className="h-10 bg-white text-sm" value={f.max} onChange={(e) => setF({ ...f, max: e.target.value })} />
        </div>
        <div className="col-span-2 lg:col-span-1">
          <label className="label-caps block mb-1">Oda</label>
          <Select value={f.oda} onValueChange={(v) => setF({ ...f, oda: v === "all" ? "" : v })}>
            <SelectTrigger data-testid="search-oda" className="h-10 bg-white text-sm"><SelectValue placeholder="—" /></SelectTrigger>
            <SelectContent>
              <SelectItem value="all">Fark etmez</SelectItem>
              {ROOMS.map((r) => <SelectItem key={r} value={r}>{r}</SelectItem>)}
            </SelectContent>
          </Select>
        </div>
        <div className="col-span-2 lg:col-span-2">
          <button
            type="submit"
            data-testid="search-submit-btn"
            className="w-full h-10 btn-accent rounded-full font-semibold text-sm flex items-center justify-center gap-2"
          >
            <Search className="w-4 h-4" /> İlan Ara
          </button>
        </div>
      </div>
    </form>
  );
};
